export const getSchemaDescription = seoMetaTags =>
  seoMetaTags?.tags?.find(
    ({ attributes }) =>
      attributes?.name === 'description' ||
      attributes?.property === 'og:description'
  )?.attributes?.content;

export const getServiceSchemaData = ({ serviceSchema, seoMetaTags, title }) => {
  const service = serviceSchema?.[0];
  const schemaDescription = getSchemaDescription(seoMetaTags);

  if (!service?.serviceType) {
    return undefined;
  }

  return {
    serviceType: service.serviceType,
    service: service.serviceAreaServed,
    name: title,
    description: schemaDescription,
  };
};
